const BFF_BASE = import.meta.env.VITE_BFF_URL ?? 'http://localhost:8081'

const TOKEN_KEY = 'quantum_token'
const USER_KEY  = 'quantum_user'

export interface AuthUser {
  id: number
  login: string
  email: string
  nome: string
}

export class AuthError extends Error {
  constructor(public status: number, message: string) {
    super(message)
    this.name = 'AuthError'
  }
}

export async function login(identificador: string, senha: string): Promise<AuthUser> {
  const res = await fetch(`${BFF_BASE}/v1/usuarios/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ login: identificador, senha }),
  })

  if (!res.ok) {
    const body = await res.json().catch(() => ({}))
    throw new AuthError(res.status, body?.erro ?? `Erro ${res.status}`)
  }

  const data = await res.json() as { token: string; usuario: AuthUser }
  localStorage.setItem(TOKEN_KEY, data.token)
  localStorage.setItem(USER_KEY, JSON.stringify(data.usuario))
  return data.usuario
}

export function logout(): void {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}

export function obterToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

export function verificarSessao(): AuthUser | null {
  const raw = localStorage.getItem(USER_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw) as AuthUser
  } catch {
    return null
  }
}
